import React from "react";
import TopperChoiceCard from "./TopperChoiceCard";
import SectionCarouselNav from "./SectionCarouselNav";
import { useHorizontalCarousel } from "../hooks/useHorizontalCarousel";
import "./TopperChoiceSection.css";

const TopperChoiceSection = ({
  topperChoice,
  highlightedAnchorId = null,
  getPackageCardHandlers,
}) => {
  const packages = topperChoice?.packages ?? [];
  const icon = topperChoice?.icon;
  const title = topperChoice?.title;
  const subTitle = topperChoice?.sub_title;

  const {
    viewportRef,
    trackRef,
    trackOffset,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    scrollByPage,
  } = useHorizontalCarousel(packages.length);

  if (!packages.length) return null;

  const titleParts = String(title || "Topper Choice").split(/\s+/);
  const highlight = titleParts[0] || "Topper";
  const rest = titleParts.slice(1).join(" ");
  const sectionTitle = title || "Topper Choice";

  return (
    <section className="dashboard-topper-choice" aria-label={sectionTitle}>
      <div className="dashboard-topper-choice__intro">
        <div className="dashboard-topper-choice__header">
          {icon ? (
            <img src={icon} alt="" className="dashboard-topper-choice__icon" aria-hidden="true" />
          ) : null}
          <div className="dashboard-topper-choice__copy">
            <h2 className="dashboard-topper-choice__title">
              <span className="dashboard-topper-choice__title-highlight">{highlight}</span>
              {rest ? ` ${rest}` : ""}
            </h2>
            {subTitle ? <p className="dashboard-topper-choice__subtitle">{subTitle}</p> : null}
          </div>
        </div>

        {hasOverflow ? (
          <SectionCarouselNav
            canScrollLeft={canScrollLeft}
            canScrollRight={canScrollRight}
            onPrev={() => scrollByPage(-1)}
            onNext={() => scrollByPage(1)}
            ariaLabel={`${sectionTitle} navigation`}
          />
        ) : null}
      </div>

      <div className="dashboard-topper-choice__carousel">
        <div ref={viewportRef} className="dashboard-topper-choice__viewport">
          <div
            ref={trackRef}
            className="dashboard-topper-choice__track"
            style={{ transform: `translate3d(-${trackOffset}px, 0, 0)` }}
          >
            {packages.map((course, index) => (
              <TopperChoiceCard
                key={course.package_id}
                course={course}
                section="topper"
                themeIndex={index}
                highlightedAnchorId={highlightedAnchorId}
                {...getPackageCardHandlers(course)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopperChoiceSection;
